<template>
    <div class="login">
        <div class="login-box">
            <h1 class="title">第七届大赛前台登录</h1>
            <Card class="login-form">
                <Form :model="loginForm" :rules="loginRules" ref="loginForm">
                    <FormItem prop="email" ref="login_email">
                        <Input v-model="loginForm.email" type="text" prefix="ios-contact" @on-enter="login"
                               placeholder="请输入邮箱"></Input>
                    </FormItem>
                    <FormItem prop="password" ref="login_password">
                        <Input v-model="loginForm.password" type="password" prefix="md-key" @on-enter="login"
                               placeholder="请输入密码"></Input>
                    </FormItem>
                </Form>
                <Button type="info" long @click="login">登录</Button>
                <router-link style="margin-right: 60%;" to="/login"><<<< 找回</router-link>
                <router-link to="/register">注册>>>></router-link>
            </Card>
        </div>
    </div>
</template>

<script>
  import { api_signUp } from '../../api/login/login'
  import { Card, Form, FormItem, Input, Button } from 'iview'
  import { auth_key } from './../../config'

  export default {
    name: 'login',
    components: {
      Card,
      Form,
      FormItem,
      Input,
      Button
    },
    data () {
      return {
        value: '',
        loginForm: {
          email: '',
          password: ''
        },
        loginRules: {
          email: [
            { required: true, message: '用户名不能为空', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '密码不能为空', trigger: 'blur' },
          ]
        }
      }
    },
    methods: {
      async login () {
        let _bool = await this.$refs.loginForm.validate()
        // 验证通过
        if (_bool) {
          this.$Message.loading({
            duration: 0,
            content: '登录中'
          })
          let _data = await api_signUp({
            email: this.loginForm.email,
            password: this.loginForm.password,
          })
          let res = _data.body
          this.$Message.destroy()
          if (res.code === 0) {
            this.$Message.success({
              duration: 1.5,
              content: res.msg,
              onClose: () => {
                sessionStorage.setItem(auth_key, res.key)
                this.$router.push({ name: 'upload' })
              }
            })
          } else {
            this.$Message.error({
              content: res.msg
            })
          }
        }
      },
    }
  }
</script>

<style lang="scss">
    .login {
        width: 100%;
        height: 100vh;
        padding-top: 23vh;
    }

    .login-box {
        width: 350px;
        margin: auto;
        text-align: center;

        .title {
            color: #2db7f5;
            font-size: 2rem;
            margin-bottom: 15px;
        }

        .login-form {
            background-color: #fdfdfd;
        }
    }
</style>
